import { createSlice } from "@reduxjs/toolkit";

export type TabsState = {
    defaultActiveKey?: string;
};

const initialState: TabsState = {
    defaultActiveKey: undefined,
};

export const tabState = createSlice({
    name: "TabSlice",
    initialState,
    reducers: {
        setDefaultActiveKey(state, action) {
            return { ...state, defaultActiveKey: action.payload ?? undefined };
        },
        clearDefaultActiveKey(state) {
            return { ...state, defaultActiveKey: undefined };
        },
    },
});

export const { setDefaultActiveKey, clearDefaultActiveKey } = tabState.actions;
